import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/global.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import * as echarts from 'echarts'
import { ElMessage } from 'element-plus'
import global from './components/global.vue'

const app = createApp(App)
app.use(store)
app.use(router)
app.use(ElementPlus, {
	locale: zhCn
})
app.config.globalProperties.$echarts = echarts
// 全局变量
app.config.globalProperties.$GLOBAL = global
app.mount('#app')

console.warn = () => { };
// createApp(App).use(store).use(router).mount('#app')

router.beforeEach((to, from, next) => {

	let is_Phone = false
	let screenWidth = document.documentElement.clientWidth
	// console.log(screenWidth)
	if (screenWidth < 1000) {
		// is_Phone= true
	}
	if (is_Phone) {

		if (to.path === "/load") {
			next()
		} else {
			next("/load")
		}

	} else {
		// console.log(to.path)
		if (to.path === "/load") {
			next("/main")
		} else {
			next()


		}

	}

})